import React from 'react';

/**
 * Page hero banner with a real photo background + dark overlay.
 * Uses regular cover (not fixed) so the photo fills the banner cleanly.
 */
const PageBanner = ({ title, subtitle, image }) => (
  <section
    className="relative py-24 sm:py-32 text-white bg-cm-primary"
    style={{
      backgroundImage: `url("${image}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
  >
    <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65" />
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h1 className="font-serif-display text-5xl sm:text-6xl mb-4 drop-shadow-lg">{title}</h1>
      {subtitle && (
        <p className="text-lg sm:text-xl max-w-3xl mx-auto font-light text-white/95 drop-shadow">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageBanner;
